import { slideToggle } from './Utilities/animations.js';

/**
 * ===== Accordions =====
 *
 * Open and closing Animations including
 * toggling aria attributes for accessibility
 */

export const initStudyprogramAccordion = () => {
    const accordionsStudyprogram = document.querySelectorAll('.studyprogram__table-col.accordion');
    let animationRunning;
    let resizeTimeout;

    if (accordionsStudyprogram.length === 0) {
        return;
    }

    // Define the toggleAccordion function before using it
    const toggleAccordion = (accordion) => {
        // Select accordion parts
        const trigger = accordion.querySelector('.accordion__trigger');
        const panel = accordion.querySelector('.accordion__panel');

        // Check if trigger and panel are not null
        if (!trigger || !panel) {
            return;
        }

        const expanded = trigger.getAttribute('aria-expanded') === 'true';

        // Toggle all attributes
        trigger.setAttribute('aria-expanded', !expanded);
        panel.setAttribute('aria-expanded', (!expanded).toString());
        panel.setAttribute('aria-hidden', expanded.toString());

        // Open and closing animation
        slideToggle(panel, 300);

        // Remove lock when finished
        setTimeout(function () {
            animationRunning = false;
        }, 300);
    };

    // Function to handle different viewport sizes
    const handleViewportChange = () => {
        // Remove existing event listeners to prevent duplicates
        accordionsStudyprogram.forEach((accordion) => {
            const trigger = accordion.querySelector('.accordion__trigger');
            const panel = accordion.querySelector('.accordion__panel');

            // Check if trigger and panel are not null
            if (!trigger || !panel) {
                return;
            }

            // Clone the trigger to remove all event listeners
            const newTrigger = trigger.cloneNode(true);
            trigger.parentNode.replaceChild(newTrigger, trigger);

            // Reset panel styles
            panel.style.removeProperty('display');
        });

        if (window.matchMedia('(max-width: 991px)').matches) {
            // If width is smaller than 992px, assign listeners for click events to each button
            accordionsStudyprogram.forEach((accordion) => {
                const trigger = accordion.querySelector('.accordion__trigger');
                const panel = accordion.querySelector('.accordion__panel');

                // Check if trigger and panel are not null
                if (!trigger || !panel) {
                    return;
                }

                // Set initial state for mobile
                panel.style.display = 'none';
                trigger.setAttribute('aria-expanded', 'false');
                panel.setAttribute('aria-expanded', 'false');
                panel.setAttribute('aria-hidden', 'true');
                trigger.disabled = false;

                trigger.addEventListener('click', () => {
                    // If any animation is still running return
                    if (animationRunning === true) {
                        return;
                    }

                    // Prevent calls during animation
                    animationRunning = true;

                    toggleAccordion(accordion);
                });
            });
        } else {
            // If width is greater than 991px, open all studyprogram accordions
            accordionsStudyprogram.forEach((accordion) => {
                const trigger = accordion.querySelector('.accordion__trigger');
                const panel = accordion.querySelector('.accordion__panel');

                // Check if trigger and panel are not null
                if (!trigger || !panel) {
                    return;
                }

                // Set expanded state for desktop
                trigger.setAttribute('aria-expanded', 'true');
                panel.setAttribute('aria-expanded', 'true');
                panel.setAttribute('aria-hidden', 'false');
                panel.style.display = 'block';
                trigger.disabled = true;
            });
        }
    };

    // Add resize event listener
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleViewportChange, 100);
    });

    // Initial call to handle viewport change
    handleViewportChange();
};
